import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const Header = () => {
  const navigate = useNavigate();
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-[#234733] bg-[#163323] text-white"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
          <img src="/data-earth-logo.webp" alt="Data Earth Surveying" className="h-10 w-10 object-contain" />
          <span className="leading-tight">
            <span className="block font-display text-base font-bold tracking-tight sm:text-lg">
              Data Earth Surveying
            </span>
            <span className="block text-[10px] uppercase tracking-[0.2em] text-[#c8a452]">
              Precision Land & Construction
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          <a href="/#services" className="text-sm text-white/80 transition-colors hover:text-white">Services</a>
          <a href="/services" className="text-sm text-white/80 transition-colors hover:text-white">How it works</a>
          <Link to="/contact" className="text-sm text-white/80 transition-colors hover:text-white">Contact</Link>
        </nav>

        <Button
          data-testid="header-request-btn"
          onClick={() => navigate("/request")}
          className="rounded-full bg-[#c8a452] px-5 font-semibold text-[#163323] shadow-none transition-transform hover:-translate-y-0.5 hover:bg-[#b38f3f]"
        >
          Request Survey
        </Button>
      </div>
    </header>
  );
};
